import React from 'react'
import Constants from '../../Constants';

export const TranslationTypeCard = ({label, icon, selected, type, onCardSelect}) => {

	const selectCardOnKeyDown = (event) => {
		if(event.key === Constants.ENTER) {
			selectCard();
		}
	}

	const selectCard = () => {
	    onCardSelect(type);
	}

  return (
		<div className="translate-box-list" role='none'>
            <a tabIndex="0" role="tab" createproject-tour="choose-vendor"
        	    onClick={selectCard}
        	    onKeyDown={(e) => selectCardOnKeyDown(e)}
        	    className={selected ?'vendor':null}
        	    aria-label={selected ? ("Current tab "+label): label}
                aria-selected={selected ? "true" : "false"}
                href="#"
        	  >
        	    {icon}
        	    <span>{label}</span>
        	  </a>
        </div>
   );
}
